import { Check } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Tag } from "@/components/portfolio/Reveal";
import { SOBRE_IMG } from "@/data/content";

export const About = () => {
  const { t } = useLang();
  const a = t.about;
  return (
    <section id="about" data-testid="about-section" className="bg-brand py-24 md:py-32">
      <div className="max-w-[88rem] mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Photo */}
        <div className="lg:col-span-5">
          <Reveal className="relative max-w-md mx-auto lg:mx-0">
            <div className="arch-top overflow-hidden bg-ink/10 aspect-[3/4]">
              <img src={SOBRE_IMG} alt="Said Kalil" className="w-full h-full object-cover object-top" />
            </div>
            <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 w-[86%] bg-white rounded-2xl shadow-xl px-6 py-4 text-center">
              <p className="font-extrabold text-lg text-ink">{a.name}</p>
              <p className="font-medium text-xs text-ink/60 mt-0.5 leading-tight">{a.role}</p>
            </div>
          </Reveal>
        </div>

        {/* Text */}
        <div className="lg:col-span-7 lg:pl-6">
          <Reveal><Tag className="bg-ink/10">{a.tag}</Tag></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-extrabold text-ink text-4xl md:text-5xl tracking-tight leading-[1.05] mt-5">
              {a.title}
            </h2>
          </Reveal>
          <div className="flex flex-col gap-5 mt-7">
            {a.body.map((p, i) => (
              <Reveal key={i} delay={0.1 + i * 0.08}>
                <p className="font-normal text-base md:text-lg text-ink/80 leading-relaxed">{p}</p>
              </Reveal>
            ))}
          </div>
          <div className="flex flex-col gap-4 mt-9">
            {a.checks.map((c, i) => (
              <Reveal key={i} delay={0.15 + i * 0.08}>
                <div className="flex items-center gap-3">
                  <span className="h-7 w-7 rounded-full bg-ink flex items-center justify-center shrink-0">
                    <Check size={15} className="text-brand" />
                  </span>
                  <span className="font-semibold text-base md:text-lg text-ink">{c}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
